/** Баннер демо-режима: объясняет, почему проект не сохраняется без авторизации. */
import { Link } from "react-router-dom";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";
import { useEditorStore } from "@/widgets/editor";

export const DemoModeBanner = ({
	isAuthenticated,
	onClose,
}: {
	isAuthenticated: boolean;
	onClose: () => void;
}) => {
	const top = useEditorStore((state) => state.overlayTopOffset);

	return (
		<div
			className="absolute left-1/2 z-40 flex max-w-viewport-gutter -translate-x-1/2 items-center gap-2 rounded-lg border border-accent/30 bg-surface/95 px-2.5 py-1.5 shadow-sm backdrop-blur-sm md:px-3 md:py-2"
			style={{ top }}
		>
			<UIKit.Text as="span" size="small" className="leading-snug">
				Изменения не сохраняются.{" "}
				<Link
					className="font-medium text-accent underline"
					to={isAuthenticated ? routerPaths.projects : routerPaths.register}
				>
					{isAuthenticated ? "Создать проект" : "Создать аккаунт"}
				</Link>{" "}
				для сохранения.
				{!isAuthenticated && (
					<>
						{" "}
						<Link className="font-medium text-accent underline" to={routerPaths.login}>
							Войти
						</Link>
					</>
				)}
			</UIKit.Text>
			<UIKit.Button
				type="button"
				border={false}
				className="ml-1 shrink-0 p-0 text-ink transition-colors hover:text-ink"
				onClick={onClose}
				aria-label="Закрыть"
			>
				✕
			</UIKit.Button>
		</div>
	);
};
